import { memo } from 'react'
import { useHistory } from 'react-router-dom'

import { Error } from 'components'
import { useCurrentLanguage } from 'lib/tolgee'
import { ZaiHeroTitle } from 'modules/zai/zai-hero-title'
import { ZaiPrePromptLink } from 'modules/zai/zai-pre-prompt-link'
import { PanelStore, UserStore } from 'stores'
import { getRoute } from 'utils/routes'
import { PATHNAMES } from 'utils/routes/consts'

import { ZaiHeroForm } from './zai-hero-form'
import { GET_ZAI_PROMPTS_QUERY_LOG } from './zai-hero.consts'
import { useZaiHeroModel } from './zai-hero.model'
import { ZaiHeroSkeletons } from './zai-hero.skeletons'
import type { TZaiHero } from './zai-hero.types'
import { ZaiHeroView } from './zai-hero.view'
import { usePrePromptsFromApi } from '../common/hooks/use-pre-prompts-from-api'

const Component: TZaiHero = ({ brandData }) => {
  const routerHistory = useHistory()
  const language = useCurrentLanguage()

  const workspaceId = Object(PanelStore?.selectedPanel)?.panelId
  const baseUrl = getRoute(PATHNAMES.WORKSPACE_ZAI, { panelId: workspaceId })

  const userZaiPreference = Object(UserStore?.userInfo)?.userPreference?.zaiPreference

  const prePromptsFromApi = usePrePromptsFromApi({ language, workspaceId, errorLog: GET_ZAI_PROMPTS_QUERY_LOG })
  const ZAI_HERO_MODEL = useZaiHeroModel({
    baseUrl,
    prePromptsData: prePromptsFromApi.data,
    routerHistoryPush: routerHistory.push,
    userZaiPreference,
  })

  return (
    <ZaiHeroView
      {...ZAI_HERO_MODEL}
      TitleComponent={ZaiHeroTitle}
      brandData={brandData}
      FormComponent={ZaiHeroForm}
      PrePromptLinkComponent={ZaiPrePromptLink}
      ErrorComponent={Error}
      SkeletonsComponent={ZaiHeroSkeletons}
      isLoading={prePromptsFromApi.isLoading}
      isError={prePromptsFromApi.isError}
      refetch={prePromptsFromApi.refetch}
    />
  )
}

export const ZaiHero = memo(Component)
